// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bib_vu bib_ql bib_va bib_gy bib_kg bib_sv","ProfileAdminTools__item":"iz_b"};